import { createAction } from "@reduxjs/toolkit";
import { TalesFood } from "../../../utils/types/TalesFood";

export const setFoodData = createAction<TalesFood[]>("food/setData");
